const isAtom = (x) => Object.prototype.hasOwnProperty.call(x, 'origin');
export class AtomList extends Array {
    configure(target, config) {
        const index = this.findIndex((x) => isAtom(x) && x.origin === target);
        if (index < 0)
            return this;
        this.splice(index, 1, target(config));
        return this;
    }
    replace(target, next) {
        const index = this.findIndex((x) => isAtom(x) && x.origin === target);
        if (index < 0)
            return this;
        this.splice(index, 1, next);
        return this;
    }
    headless() {
        this.filter(isAtom).forEach((x) => {
            this.configure(x.origin, { headless: true });
        });
        return this;
    }
    static create(from) {
        return new AtomList(...from);
    }
}
//# sourceMappingURL=atom-list.js.map